import { CLOUD_API } from "@skydio/api_util/src";
import { makeWrappedSelector } from "@skydio/redux_util/src";

import type { AppState } from "./store";

export const getFeatureFlags = (state: AppState) => state.featureFlags.featureFlags;

export const getFeatureFlagValue = makeWrappedSelector(
  CLOUD_API.modules.featureFlags.selectors.getFeatureFlagValue,
  (state: AppState) => state.featureFlags
);

export const isFeatureFlagRequestStateActive = makeWrappedSelector(
  CLOUD_API.modules.featureFlags.selectors.isFeatureFlagRequestStateActive,
  (state: AppState) => state.featureFlags
);

export const isFeatureFlagRequestStateCompleted = makeWrappedSelector(
  CLOUD_API.modules.featureFlags.selectors.isFeatureFlagRequestStateCompleted,
  (state: AppState) => state.featureFlags
);
